import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { PayerSelect } from '../../../Header/LogoActionBar/PayerSelect';
import { ProviderSelect } from '../../../Header/LogoActionBar/ProviderSelect';
import { ProviderSelectDrawer } from '../../../Header/LogoActionBar/ProviderSelectDrawer';

const FlexDivLessShrink = styled('div', {
  flex: '1 0.8 auto',
});

const JustifyRight = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
});

const DropdownWrapper = styled('div', {
  paddingLeft: '8px',
});

export const PayerProvider = ({ setDigitalSecurityError }) => (
  <React.Fragment>
    <FlexDivLessShrink>
      <JustifyRight data-testid="payer-provider-wrapper">
        <DropdownWrapper>
          <PayerSelect />
        </DropdownWrapper>
        <DropdownWrapper>
          <Choose>
            <When condition={getFeature('PROVIDER_SELECT_REDESIGN')}>
              <ProviderSelectDrawer
                setDigitalSecurityError={setDigitalSecurityError}
              />
            </When>
            <Otherwise>
              <ProviderSelect
                setDigitalSecurityError={setDigitalSecurityError}
              />
            </Otherwise>
          </Choose>
        </DropdownWrapper>
      </JustifyRight>
    </FlexDivLessShrink>
  </React.Fragment>
);

PayerProvider.propTypes = {
  setDigitalSecurityError: PropTypes.func.isRequired,
};
